import React from 'react'

const Edit: React.FC = () => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="32"
		height="33"
		fill="none"
		viewBox="0 0 32 33"
		className="cursor-pointer group"
	>
		<rect
			width="32"
			height="32.001"
			className="transition-colors fill-brand-gray-100 group-hover:fill-brand-primary-light"
			rx="16"
		/>
		<path
			className="transition-colors fill-brand-gray-200 group-hover:fill-brand-primary-md"
			fillRule="evenodd"
			d="M21.755 11.411l-1.088-1.094a1.077 1.077 0 00-1.527 0l-1.043 1.048 2.442 2.453 1.216-1.222a.84.84 0 000-1.185zm-4.292.592l2.441 2.453-6.18 6.21-2.44-2.453 6.18-6.21zm-7.12 9.99a.278.278 0 01-.336-.332l.616-2.784 2.44 2.453-2.72.663z"
			clipRule="evenodd"
		/>
	</svg>
)

export default Edit
